import { createContext } from 'react';

import { NotOnContractItems } from '@totem/components/salesOrders/decommissioning/types';

interface Context {
  loading: boolean;
  reportData: NotOnContractItems;
  totalRecords: number;
  searchText: string;
  setSearchText: (val: string) => void;
  refetch: () => void;
}

const DecommissioningReportContext = createContext<Context>({
  loading: false,
  reportData: [],
  totalRecords: 0,
  searchText: '',
  setSearchText: () => {},
  refetch: () => {},
});

export default DecommissioningReportContext;
